(function () {
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cascabel-placa-razas]').forEach(initBreedTagForm);
  });

  function initBreedTagForm(root) {
    const form = root.closest('form');
    const select = root.querySelector('[data-cpr-breed]');
    const preview = root.querySelector('[data-cpr-preview]');
    const previewImage = root.querySelector('[data-cpr-preview-image]');
    const alert = root.querySelector('[data-cpr-alert]');

    fetch(root.dataset.razasUrl)
      .then((response) => response.json())
      .then((data) => {
        (data.items || []).forEach((item) => {
          const option = document.createElement('option');
          option.value = item.name;
          option.textContent = item.name;
          option.dataset.imageUrl = item.imageUrl;
          select.appendChild(option);
        });
      })
      .catch(() => {
        setAlert(alert, 'No pudimos cargar las razas. Recarga la pagina para intentarlo de nuevo.');
      });

    select.addEventListener('change', function () {
      const option = select.selectedOptions[0];
      const imageUrl = option && option.dataset.imageUrl;
      clearField(select);

      if (!imageUrl) {
        preview.hidden = true;
        previewImage.removeAttribute('src');
        previewImage.alt = '';
        return;
      }

      previewImage.src = imageUrl;
      previewImage.alt = `Plaquita de ${select.value}`;
      preview.hidden = false;
    });

    root.addEventListener('input', function (event) {
      clearField(event.target);
      setAlert(alert, '');
    });

    root.addEventListener('change', function (event) {
      clearField(event.target);
      setAlert(alert, '');
    });

    if (form) {
      form.addEventListener(
        'submit',
        function (event) {
          const firstInvalid = validate(root);
          if (!firstInvalid) return;

          event.preventDefault();
          event.stopImmediatePropagation();
          setAlert(alert, 'Revisa los campos marcados antes de agregar tu plaquita al carrito.');
          firstInvalid.focus({ preventScroll: true });
          firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        },
        true
      );
    }
  }

  function validate(root) {
    let firstInvalid = null;

    root.querySelectorAll('[data-cpr-field]').forEach((field) => {
      field.classList.remove('is-invalid');
      const error = field.querySelector('[data-cpr-error]');
      if (error) error.textContent = '';
    });

    const controls = Array.from(root.querySelectorAll('[required]'));
    controls.forEach((control) => {
      if (isValid(control)) return;

      markInvalid(control, messageFor(control));
      if (!firstInvalid) firstInvalid = control;
    });

    return firstInvalid;
  }

  function isValid(control) {
    if (control.type === 'checkbox') return control.checked;
    return String(control.value || '').trim().length > 0;
  }

  function messageFor(control) {
    if (control.matches('[data-cpr-breed]')) return 'Elige el diseño de la plaquita.';
    if (control.name === 'properties[Nombre de la mascota]') return 'Escribe el nombre de tu mascota.';
    if (control.name === 'properties[Datos de contacto]') return 'Escribe los datos de contacto.';
    if (control.type === 'checkbox') return 'Confirma que los datos están correctos.';
    return 'Completa este campo.';
  }

  function markInvalid(control, message) {
    const field = control.closest('[data-cpr-field]');
    if (!field) return;
    field.classList.add('is-invalid');
    const error = field.querySelector('[data-cpr-error]');
    if (error) error.textContent = message;
  }

  function clearField(control) {
    const field = control && control.closest && control.closest('[data-cpr-field]');
    if (!field) return;
    field.classList.remove('is-invalid');
    const error = field.querySelector('[data-cpr-error]');
    if (error) error.textContent = '';
  }

  function setAlert(alert, message) {
    if (alert) alert.textContent = message || '';
  }
})();
